import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 980.000000 978.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,978.000000) scale(0.100000,-0.100000)">
<path d="M5288 8343 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5460 8320 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"/>
<path d="M4193 8283 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M5533 8283 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M4088 8253 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3860 8210 c-12 -8 -9 -10 13 -10 16 0 26 4 22 10 -8 12 -16 12 -35
0z"/>
<path d="M3775 8190 c-33 -10 -50 -19 -38 -19 12 -1 23 -4 26 -8 2 -5 2 -2 0
6 -2 9 4 12 19 9 14 -3 31 3 42 14 11 10 18 18 15 17 -2 0 -31 -9 -64 -19z"/>
<path d="M5916 8201 c-4 -5 3 -7 14 -4 23 6 26 13 6 13 -8 0 -17 -4 -20 -9z"/>
<path d="M6010 8180 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"/>
<path d="M3670 8150 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M3591 8121 c-37 -15 -41 -19 -23 -23 12 -4 20 -2 17 2 -3 4 9 13 25
19 17 5 30 12 30 15 0 7 3 8 -49 -13z"/>
<path d="M3483 8068 c2 -7 10 -13 17 -13 7 0 15 6 18 13 2 7 -5 12 -18 12 -13
0 -20 -5 -17 -12z"/>
<path d="M3376 8025 c-111 -55 -127 -70 -45 -41 67 24 109 46 109 58 0 4 7 5
15 2 9 -4 15 0 15 10 0 9 -1 16 -2 15 -2 0 -43 -20 -92 -44z"/>
<path d="M3075 7860 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M2985 7800 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M2610 7504 c0 -8 5 -12 10 -9 6 4 8 11 5 16 -9 14 -15 11 -15 -7z"/>
<path d="M7225 7430 c21 -24 26 -25 19 -6 -3 8 -13 17 -22 21 -13 5 -13 2 3
-15z"/>
<path d="M7310 7345 c7 -8 17 -15 22 -15 6 0 5 7 -2 15 -7 8 -17 15 -22 15 -6
0 -5 -7 2 -15z"/>
<path d="M7375 7280 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M5420 6719 c-14 -6 -52 -14 -85 -17 l-60 -7 -3 -65 c-6 -136 55 -286
136 -333 41 -24 71 -17 121 28 61 56 94 140 99 261 l4 100 -71 14 c-40 7 -74
17 -77 22 -7 11 -33 9 -64 -3z"/>
<path d="M5660 6328 c-51 -77 -105 -111 -186 -116 -105 -7 -194 42 -240 131
-8 15 -18 27 -22 27 -4 0 -7 -316 -7 -703 l0 -702 23 -56 c30 -75 97 -142 169
-169 74 -27 289 -41 298 -19 3 8 4 384 3 837 l-3 823 -35 -53z"/>
<path d="M1725 6359 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M1626 6115 c-3 -10 -3 -22 3 -28 12 -12 20 4 11 27 -6 19 -7 19 -14
1z"/>
<path d="M1596 6045 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M4654 4989 c4 -72 9 -88 51 -159 15 -25 63 -62 110 -85 29 -13 69
-20 148 -23 l107 -4 -2 133 c-2 126 -2 129 -8 49 -5 -70 -7 -78 -11 -45 -5 30
-6 27 -3 -14 3 -58 -4 -58 -36 0 -10 20 -24 32 -32 29 -7 -2 -49 -6 -93 -8
-44 -2 -82 -7 -85 -12 -3 -4 -21 0 -40 9 -25 11 -37 25 -41 46 -5 24 -6 23 -4
-9 3 -35 2 -37 -11 -18 -8 11 -12 27 -9 35 3 7 -1 20 -10 27 -8 7 -15 29 -16
49 0 20 -5 45 -10 56 -6 14 -8 -4 -5 -56z m351 -179 c-3 -5 -15 -10 -26 -10
-10 0 -19 5 -19 10 0 6 12 10 26 10 14 0 23 -4 19 -10z m-125 -20 c0 -5 -2
-10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11 -10z"/>
<path d="M4061 4994 c0 -16 4 -38 9 -49 6 -13 7 -5 3 25 -7 53 -13 66 -12 24z"/>
<path d="M4880 4916 c0 -9 7 -16 16 -16 9 0 14 5 12 12 -6 18 -28 21 -28 4z"/>
<path d="M4467 4878 c-5 -27 -6 -52 -3 -57 4 -5 3 -17 0 -26 -5 -13 -8 -14
-15 -3 -6 10 -11 9 -23 -7 -12 -15 -15 -16 -16 -5 0 12 -2 12 -8 2 -6 -8 -31
-13 -73 -12 -86 0 -99 2 -93 11 8 14 -18 22 -27 8 -8 -12 -11 -11 -20 4 -5 9
-17 17 -25 17 -8 0 -13 4 -10 8 3 5 -4 15 -16 23 -11 8 -24 24 -29 37 -5 12
-14 22 -21 21 -10 0 -10 -2 0 -6 6 -2 12 -12 12 -22 0 -10 16 -36 36 -59 56
-66 130 -92 261 -92 45 0 84 3 86 8 2 4 1 50 -2 102 -6 89 -7 92 -14 48z"/>
<path d="M4778 4893 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8353 4755 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z"/>
<path d="M8340 4405 c0 -8 2 -15 4 -15 2 0 6 7 10 15 3 8 1 15 -4 15 -6 0 -10
-7 -10 -15z"/>
<path d="M5030 4363 c-56 -21 -68 -87 -24 -122 30 -24 55 -26 87 -10 30 16 37
28 37 65 0 46 -56 84 -100 67z"/>
<path d="M4771 4346 c-57 -20 -90 -84 -91 -173 0 -32 -1 -33 -45 -33 l-45 0 0
-50 0 -50 45 0 45 0 0 -240 0 -241 61 3 61 3 -1 238 -2 237 61 0 60 0 0 50 0
50 -61 0 -60 0 6 48 c8 56 25 72 77 72 l38 0 0 50 0 50 -57 -1 c-32 0 -74 -6
-92 -13z"/>
<path d="M2060 3950 l0 -400 60 0 60 0 0 42 0 42 33 -31 c49 -46 76 -57 147
-57 109 0 200 68 235 174 21 62 21 187 0 249 -55 168 -254 234 -376 124 l-39
-35 0 146 0 146 -60 0 -60 0 0 -400z m336 80 c65 -25 100 -108 92 -214 -7 -77
-31 -122 -80 -147 -120 -62 -238 26 -238 176 0 143 107 230 226 185z"/>
<path d="M5285 4248 l0 -103 -42 -3 -43 -3 0 -49 0 -49 43 -3 42 -3 5 -213 5
-214 33 -29 c32 -29 37 -30 115 -27 l82 3 0 45 0 45 -45 5 c-25 3 -51 9 -57
13 -10 6 -13 56 -13 193 l0 184 61 0 60 0 -3 48 -3 47 -59 5 -58 5 -2 100 -1
100 -60 3 -60 3 0 -103z"/>
<path d="M6030 4204 l0 -146 -39 35 c-109 98 -288 57 -361 -83 -51 -98 -46
-247 11 -346 73 -129 255 -160 355 -63 l34 33 0 -42 0 -42 60 0 60 0 0 400 0
400 -60 0 -60 0 0 -146z m-62 -190 c43 -32 72 -99 72 -169 0 -115 -65 -195
-159 -195 -102 0 -160 70 -161 191 0 96 33 162 95 190 33 15 123 4 153 -17z"/>
<path d="M6920 4245 l0 -105 -45 0 -45 0 0 -50 0 -50 45 0 45 0 0 -205 c0
-174 3 -210 16 -231 27 -40 65 -54 149 -54 l75 0 0 50 0 50 -41 0 c-80 0 -79
-3 -79 205 l0 185 60 0 60 0 0 50 0 50 -60 0 -60 0 0 105 0 105 -60 0 -60 0 0
-105z"/>
<path d="M2913 4140 c-135 -29 -233 -170 -219 -318 10 -114 60 -194 156 -250
39 -24 55 -27 125 -26 115 1 197 41 250 122 39 60 37 75 -10 75 -72 0 -81 -3
-94 -27 -20 -36 -81 -66 -138 -66 -62 0 -113 33 -142 93 -39 81 -50 77 207 77
l228 0 -6 63 c-8 74 -36 141 -76 181 -66 65 -182 97 -281 76z m174 -118 c33
-23 68 -86 58 -102 -8 -13 -312 -12 -320 0 -11 18 31 82 70 106 52 32 144 30
192 -4z"/>
<path d="M3585 4132 c-22 -11 -49 -29 -59 -41 -27 -30 -36 -26 -36 14 l0 35
-60 0 -60 0 0 -295 0 -295 59 0 59 0 4 198 c3 176 5 201 23 232 50 86 186 90
215 6 5 -16 10 -120 10 -232 l0 -204 61 0 60 0 -3 238 -3 239 -27 40 c-31 47
-75 70 -149 78 -41 4 -64 1 -94 -13z"/>
<path d="M4177 4139 c-127 -30 -206 -127 -215 -265 -9 -142 42 -242 153 -299
51 -26 69 -30 134 -29 108 1 187 43 243 127 44 66 39 76 -29 70 -46 -4 -62
-10 -77 -29 -26 -35 -88 -64 -136 -64 -46 0 -85 17 -117 52 -21 23 -53 87 -53
108 0 6 79 10 230 10 l230 0 0 28 c0 50 -27 142 -53 181 -37 55 -83 88 -152
106 -65 17 -101 18 -158 4z m151 -108 c48 -25 70 -50 78 -90 l7 -32 -157 2
c-173 1 -180 4 -152 58 39 74 143 103 224 62z"/>
<path d="M6438 4136 c-76 -20 -141 -82 -163 -153 -6 -22 -4 -23 55 -23 55 0
61 2 70 25 13 34 67 65 113 65 68 0 111 -36 119 -99 3 -24 -2 -25 -128 -51
-149 -31 -180 -45 -223 -97 -38 -46 -42 -112 -11 -173 51 -99 225 -117 327
-34 l43 35 0 -40 c0 -41 0 -41 38 -41 20 0 48 3 61 7 l24 6 -5 207 c-5 178 -9
213 -26 251 -27 61 -70 98 -133 114 -65 18 -99 18 -161 1z m197 -348 c-10 -64
-35 -100 -85 -126 -84 -43 -180 -15 -180 52 0 37 7 49 40 66 29 16 162 48 203
49 28 1 29 0 22 -41z"/>
<path d="M7388 4127 c-32 -14 -67 -35 -78 -48 -24 -28 -60 -93 -60 -109 0 -6
25 -10 59 -10 50 0 61 3 66 20 12 38 63 70 112 70 73 0 123 -42 123 -103 0
-21 -9 -25 -122 -46 -201 -38 -258 -80 -258 -189 0 -110 68 -167 196 -166 59
1 80 5 118 28 26 15 50 35 54 44 5 12 9 4 12 -23 5 -39 6 -40 45 -41 82 -1 77
-18 73 232 l-3 222 -30 43 c-63 89 -197 122 -307 76z m222 -331 c0 -69 -31
-114 -97 -142 -56 -24 -132 -14 -155 20 -11 16 -10 64 2 86 11 20 55 37 145
56 101 20 105 19 105 -20z"/>
<path d="M5000 3845 l0 -295 60 0 60 0 0 295 0 295 -60 0 -60 0 0 -295z"/>
<path d="M7946 3245 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M1840 3204 c0 -13 18 -39 24 -34 2 3 -2 14 -10 24 -8 11 -14 16 -14
10z"/>
<path d="M1997 2943 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M2121 2774 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M2147 2725 c-4 -8 -2 -17 3 -20 6 -4 10 3 10 14 0 25 -6 27 -13 6z"/>
<path d="M7626 2724 c-5 -14 -4 -15 9 -4 17 14 19 20 6 20 -5 0 -12 -7 -15
-16z"/>
<path d="M2178 2677 c12 -7 20 -15 17 -18 -3 -3 4 -14 15 -24 21 -19 28 -7 8
13 -7 7 -8 12 -4 12 5 0 3 7 -4 15 -7 8 -22 15 -34 15 -21 -1 -21 -1 2 -13z"/>
<path d="M7570 2674 c0 -8 5 -12 10 -9 6 3 10 10 10 16 0 5 -4 9 -10 9 -5 0
-10 -7 -10 -16z"/>
<path d="M2237 2626 c-4 -10 -5 -21 -2 -24 9 -9 17 6 13 25 -3 17 -4 17 -11
-1z"/>
<path d="M7512 2606 c-8 -18 -8 -25 1 -29 7 -3 12 7 13 24 1 35 0 36 -14 5z"/>
<path d="M2255 2600 c-4 -7 -1 -18 7 -26 13 -13 15 -12 13 5 -2 26 -11 36 -20
21z"/>
<path d="M2291 2568 c0 -7 4 -22 9 -33 8 -18 9 -17 9 7 1 15 -3 30 -9 33 -5 3
-10 0 -9 -7z"/>
<path d="M7485 2559 c-11 -17 1 -21 15 -4 8 9 8 15 2 15 -6 0 -14 -5 -17 -11z"/>
<path d="M2350 2506 c0 -2 7 -7 16 -10 8 -3 12 -2 9 4 -6 10 -25 14 -25 6z"/>
<path d="M2390 2450 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"/>
<path d="M2450 2396 c0 -3 9 -10 20 -16 11 -6 20 -8 20 -6 0 3 -9 10 -20 16
-11 6 -20 8 -20 6z"/>
<path d="M2508 2343 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2556 2293 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M2580 2280 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M2610 2241 c0 -6 16 -21 35 -34 19 -13 32 -27 28 -31 -4 -4 0 -4 10
0 9 3 17 8 17 10 0 1 -20 17 -45 34 -25 17 -45 26 -45 21z"/>
<path d="M7145 2229 c-4 -6 -5 -12 -2 -15 2 -3 7 2 10 11 7 17 1 20 -8 4z"/>
<path d="M2736 2145 c4 -8 12 -15 20 -15 20 0 17 7 -6 20 -16 9 -18 8 -14 -5z"/>
<path d="M7060 2149 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M3055 1920 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"/>
<path d="M3655 1625 c34 -16 64 -20 50 -6 -6 4 -26 11 -45 14 l-35 6 30 -14z"/>
<path d="M6110 1630 c-8 -5 -10 -10 -5 -10 6 0 17 5 25 10 8 5 11 10 5 10 -5
0 -17 -5 -25 -10z"/>
<path d="M4155 1480 c3 -5 18 -10 32 -10 32 0 28 5 -10 14 -19 4 -26 3 -22 -4z"/>
<path d="M4368 1443 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M5328 1433 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M5425 1430 c-18 -8 -18 -9 5 -9 14 0 34 4 45 9 18 8 18 9 -5 9 -14 0
-34 -4 -45 -9z"/>
<path d="M5178 1423 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5248 1423 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M4658 1413 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M4808 1403 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M4938 1403 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
